<template>
  <div>
    <el-dialog title="密钥管理" :visible.sync="visible" width="860px" @open="openHandler" @closed="closedHandler">
      <div>
        <el-table 
        :data="keys.filter(key => !search || key.name.toLowerCase().includes(search.toLowerCase()))" 
        height="550" 
        border 
        style="width: 100%" 
        :header-row-style="{height: '3.5em', 'text-align': 'left'}"
        :row-style="{height: '3em', 'text-align': 'left'}"
        >
          <el-table-column prop="name" label="密钥名" />
          <el-table-column prop="addTime" label="添加时间" />
          <el-table-column  width="200" align="right">
            <template slot="header" slot-scope="scope">
              <!-- 这里必须有 slot-scope, 否则输入框只能输入单个字符, 放到一个不可见的 span 中确保能编译 -->
              <span v-if="false">{{scope}}</span>
              <div class="hdr-tools">
                <el-input :id="focusID" v-model="search" size="mini" placeholder="搜索密钥" />
                <el-tooltip content="添加证书" placement="bottom-end">
                  <el-button @click="addHandler" class="el-icon-plus hdr-btn" type="primary" size="mini" circle />
                </el-tooltip>
              </div>
            </template>
            <template slot-scope="scope" style="margin: 1em 0;">
              <el-button size="mini" @click="editHandler(scope.row.name, scope.row.raw)" class="el-icon-edit" />
              <el-button size="mini" @click="detailsHandler(scope.$index, scope.row)" class="el-icon-tickets" />
              <el-popconfirm title="确认删除密钥?" @confirm="delHandler(scope.row.name)" >
                <el-button slot="reference" class="el-icon-delete row-tool-btn" size="mini" type="danger" />
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog :title="detailsName" :visible.sync="detailsVisible" width="600px" top="7vh" :close-on-click-modal="false">
      <key-details :name="detailsName" :keyPair="detailsKey" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="editHandler(detailsName, detailsKey)" size="mini">修 改</el-button>
        <el-button type="primary" @click="detailsVisible = false" size="mini">关 闭</el-button>
      </span>
    </el-dialog>

    <add-key ref="addKey" @close="show()" />

    <edit-key ref="editKey" @success="loadKeys" />
  </div>
</template>

<script>
import addKey from './addKey.vue'
import KeyDetails from './keyDetails.vue'
import EditKey from "./editKey";

export default {
  components: {EditKey, addKey, KeyDetails },
  name: "keys",
  data() {
    return {
      visible: false,
      search: "",
      focusID: "keys-search",
      keys: [],
      downloadTarget: "privateKey", // privateKey/publicKey

      detailsName: undefined,
      detailsKey: undefined,
      detailsVisible: false,
    }
  },
  mounted() {
    let self = this
    self.env.ui.showKeysAddCallback(() => {
      self.visible = true
    })
  },
  methods: {
    show() {this.visible = true},
    hide() {this.visible = false},
    openHandler: function() {
      this.utils.domFocusById(this.focusID)
      this.loadKeys()
    },
    closedHandler: function() {this.env.termFocusCurrent()},
    editHandler: function(name, keyPair) { this.$refs.editKey.show(name, keyPair) },
    detailsHandler: function(index, row) {
      console.log("detailsHandler: ", index, ": ", row)
      this.detailsName = row.name
      this.detailsKey = row.raw
      this.detailsVisible = true
    },
    delHandler: function(name) {
      let self = this
      let path = this.env.key.getPathByName(name) // String | 需要删除的目录的完整路径
      self.api.hifs.deleteDir(path, (error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
        } else {
          self.$message.success(`删除密钥 ${name} 成功`)
          self.loadKeys()
        }
      })
    },
    addHandler: function() {
      this.hide()
      this.$refs.addKey.show()
    },
    loadKeys() {
      let self = this
      self.api.hifs.getDirSubsData(self.env.key.basePath, (error, data, response) => {
        if (error) {
          console.error(error);
          self.$message.error(`${response.statusCode}: ${response.text}`)
        } else {
          console.log("data:", data)
          self.keys = []
          if (!data || !data.Files || data.Files.length < 1) return
          for (let f of data.Files) {
            // console.log("f:", f)
            let keyPair = this.model.NewKeyPairFromJSON(window.atob(f.Data))
            let k = {
              name: f.Name,
              addTime: self.utils.shortHumanTime(f.CreatedTime),
              passphrase: keyPair.Passphrase ? keyPair.Passphrase : "无",
              raw: keyPair,
            }
            // console.log("k:", k)
            self.keys.push(k)
          }
        }
      })
    },
  },
}
</script>

<style scoped>
.hdr-tools {
  display: flex;
}
.hdr-btn {
  margin-left: 8px;
}
.row-tool-btn {
  margin-left: 8px;
}
</style>
